'use client';
import { Flex } from '@chakra-ui/react';
import { usePathname, useSearchParams } from 'next/navigation';
import { getPrimarySection } from './primary-navigation';
import { useAppRail } from './AppRailContext';
import { SidePanelToggleButton } from './SidePanelToggleButton';

/** The top-bar toggle exists only while the panel is visually collapsed. */
export function CollapsedRailControls() {
  const { railVisuallyCollapsed, railStateReady, railToggleLabel, toggleRailCollapsed } =
    useAppRail();
  const section = getPrimarySection(usePathname(), useSearchParams());
  if (!railVisuallyCollapsed || !railStateReady || section === 'site' || section === 'canvas')
    return null;
  return (
    <Flex display={{ base: 'none', lg: 'flex' }} align="center" mr="2" flexShrink={0}>
      <SidePanelToggleButton
        side="left"
        open={false}
        label={railToggleLabel}
        controls="app-navigation-rail"
        onClick={toggleRailCollapsed}
      />
    </Flex>
  );
}
